import { useMutation, useQueryClient } from '@tanstack/react-query';

import { BundleItemCreate } from '~/components/Cruises/pages/Bundles/types';

import bundlesService from '~/services/cruises/BundlesService';

import { bundleQueryKeys } from './bundleQueryKeys';

interface CreateBundleItemParams {
  bundleId: string;
  data: BundleItemCreate;
}

interface DeleteBundleItemParams {
  bundleId: string;
  itemId: string;
}

export function useCreateBundleItem() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ bundleId, data }: CreateBundleItemParams) => {
      return await bundlesService.createItem(bundleId, data);
    },
    onSuccess: (_result, variables) => {
      queryClient.invalidateQueries({ queryKey: bundleQueryKeys.items(variables.bundleId) });
    },
  });
}

export function useDeleteBundleItem() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ bundleId, itemId }: DeleteBundleItemParams) => {
      return await bundlesService.deleteItem(bundleId, itemId);
    },
    onSuccess: (_result, variables) => {
      queryClient.invalidateQueries({ queryKey: bundleQueryKeys.items(variables.bundleId) });
    },
  });
}
